import type { ReactNode } from 'react';

interface NestedRouteProps {
  children: ReactNode;
}

function NestedRoute({ children }: NestedRouteProps) {
  return <>{children}</>;
}

export default NestedRoute;
